import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Paper,
} from "@mui/material";
import _ from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IOrderListFilterProps } from "./interfaces";
import React from "react";
import { LocationDefaultReadyTimeChange } from "components/location/location-default-ready-time-change";
import { CurrentTime } from "components/common/current-time";
import { css } from "@emotion/css";

export const OrderListFilter: React.FC<IOrderListFilterProps> = (
  props: IOrderListFilterProps
) => {
  const { t } = useTranslation(["commonTranslation"]);
  const [showWithoutEmployee, setShowWithoutEmployee] = useState<boolean>(
    props.showWithoutEmployee
  );
  const [showDeliveredOrder, setShowDeliveredOrder] = useState<boolean>(
    props.showDeliveredOrder
  );
  const [showMap, setShowMap] = useState<boolean>(props.showMap);
  const [showOnlyActiveEmployees, setShowOnlyActiveEmployees] =
    useState<boolean>(props.showOnlyActiveEmployees);
  const [showExternalEmployees, setShowExternalEmployees] =
    useState<boolean>(props.showExternalEmployees);

  return (
    <Paper>
      <Box padding={"5px"}>
        <FormGroup row={true}>
          <FormControlLabel
            control={<CurrentTime />}
            label=""
            className={css`
              margin-left: 0;
              font-size: larger;
            `}
          />
          <div>
            <FormGroup row={false}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showDeliveredOrder}
                    sx={{ padding: "0px" }}
                    onChange={(
                      event: React.ChangeEvent<HTMLInputElement>,
                      isChecked: boolean
                    ) => {
                      setShowDeliveredOrder(isChecked);
                      if (isChecked) {
                        setShowWithoutEmployee(false);
                        props.handleSetShowWithoutEmployeeOnClick(false);
                      }
                      props.handleSetShowDeliveredOrderOnClick(isChecked);
                    }}
                  />
                }
                label={`+${t("deliveredOrders")}`}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showWithoutEmployee}
                    sx={{ padding: "0px" }}
                    onChange={(
                      event: React.ChangeEvent<HTMLInputElement>,
                      isChecked: boolean
                    ) => {
                      setShowWithoutEmployee(isChecked);
                      if (isChecked) {
                        setShowDeliveredOrder(false);
                        props.handleSetShowDeliveredOrderOnClick(false);
                      }
                      props.handleSetShowWithoutEmployeeOnClick(isChecked);
                    }}
                  />
                }
                label={t("withoutEmployee")}
              />
            </FormGroup>
          </div>

          {props.locationDetails.isAssignNotLoggedDriverEnabled && (
            <div>
              <FormGroup row={false}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showOnlyActiveEmployees}
                      sx={{ padding: "0px" }}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>,
                        isChecked: boolean
                      ) => {
                        setShowOnlyActiveEmployees(isChecked);
                        props.handleShowOnlyActiveEmployeesOnClick(isChecked);
                      }}
                    />
                  }
                  label={t("activeDrivers")}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showExternalEmployees}
                      sx={{ padding: "0px" }}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>,
                        isChecked: boolean
                      ) => {
                        setShowExternalEmployees(isChecked);
                        props.handleShowExternalEmployeesOnClick(isChecked);
                      }}
                    />
                  }
                  label={t("externalEmployees")}
                />
              </FormGroup>
            </div>
          )}

          <FormControlLabel
            control={
              <Checkbox
                checked={showMap}
                onChange={(
                  event: React.ChangeEvent<HTMLInputElement>,
                  isChecked: boolean
                ) => {
                  setShowMap(isChecked);
                  props.handleShowMapOnClick(isChecked);
                }}
              />
            }
            label={t("showMap")}
          />
          <LocationDefaultReadyTimeChange
            defaultOrderReadyTimeInMinutes={
              props.defaultOrderReadyTimeInMinutes
            }
            handleSetDefaultOrderReadyTimeInMinutesOnSave={(
              defaultOrderReadyTimeInMinutes
            ) => {
              props.handleSetDefaultOrderReadyTimeInMinutesOnSave(
                defaultOrderReadyTimeInMinutes
              );
            }}
          />
        </FormGroup>
      </Box>
    </Paper>
  );
};
